import { Space } from 'antd';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';

export const TitleContainer = styled(Space).attrs({
  size: 'small',
  align: 'center',
})`
  width: 100%;
  padding: var(--layout-01) var(--layout-01) calc(var(--layout-01) - 1px);
  border-bottom: 1px solid var(--border-color);
  ${BodyShort01};
`;
